import { Routes } from '@angular/router';
import { AppShell } from './core/layout/shell/app-shell';
import { authGuard } from './core/auth/auth.guard';
import { superAdminGuard } from './core/auth/super-admin.guard';
import { ROUTE_PATHS } from './core/routing/route-paths';

export const routes: Routes = [
  {
    path: '',
    redirectTo: ROUTE_PATHS.QUICK_ACCESS,
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: '',
    component: AppShell,
    canActivate: [authGuard],
    children: [
      {
        path: 'quick-access',
        loadComponent: () =>
          import('./features/quick-access/presentation/pages/quick-access-page/quick-access-page').then(
            (m) => m.QuickAccessPage
          ),
      },
      {
        path: 'dashboard',
        canActivate: [superAdminGuard],
        loadComponent: () =>
          import('./features/dashboard/presentation/pages/dashboard-page/dashboard-page').then(
            (m) => m.DashboardPage
          ),
      },
      {
        path: 'users',
        loadChildren: () => import('./features/users/users.routes').then((m) => m.usersRoutes),
      },
      {
        path: 'organizations',
        loadChildren: () =>
          import('./features/organizations/organizations.routes').then((m) => m.organizationsRoutes),
      },
      {
        path: 'identity-providers',
        loadChildren: () =>
          import('./features/identity-providers/identity-providers.routes').then(
            (m) => m.identityProvidersRoutes
          ),
      },
      {
        path: 'oauth-clients',
        loadChildren: () =>
          import('./features/clients/clients.routes').then((m) => m.clientsRoutes),
      },
      {
        path: 'platform-access',
        loadChildren: () =>
          import('./features/platform-access/platform-access.routes').then((m) => m.platformAccessRoutes),
      },
      {
        path: 'api-access',
        loadChildren: () => import('./features/api-access/api-access.routes').then((m) => m.apiAccessRoutes),
      },
      {
        path: 'roles',
        loadChildren: () => import('./features/roles/roles.routes').then((m) => m.rolesRoutes),
      },
      {
        path: 'security',
        loadChildren: () => import('./features/security/security.routes').then((m) => m.securityRoutes),
      },
      {
        path: 'audit',
        loadChildren: () => import('./features/audit/audit.routes').then((m) => m.auditRoutes),
      },
      {
        path: 'monitoring/oidc',
        loadComponent: () =>
          import('./features/oidc-operations/presentation/pages/oidc-operations-page/oidc-operations-page').then(
            (m) => m.OidcOperationsPage
          ),
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./features/profile/presentation/pages/profile-page/profile-page').then(
            (m) => m.ProfilePage
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: ROUTE_PATHS.LOGIN,
  },
];
